import {useQuery} from "@tanstack/react-query";
import {invDetailInit} from "../state";
import {readInvDetail} from "../../../../../api/inventory/InvApi";

type Props = {
    id: number;
};

export const useReadInvDetail = ({id}: Props) => {
    const {data} = useQuery({
        queryKey: ["readInvDetail", id],
        queryFn: async () => await readInvDetail(id),
        select: (res) => res?.data.result?.inventoryDetail ?? invDetailInit,
        enabled: id !== 0
    });

    return {data};
};
